<template>
  <div class="layout-content-list">
    <el-breadcrumb separator="/" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>物流圈</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ getName }}设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="blacklist-tips-con">
      <i class="el-icon-warning"></i><span class="pl-10">{{ getTip }}</span>
    </div>
    <div class="tab-nav-custom" id="auto-0">
      <el-tabs v-model="tabActive" @tab-click="tabChange" class="yellow-control-tab">
        <el-tab-pane :label="`司机${getName}`" name="driver">
          <list-driver v-if="tabActive == 'driver'" :type="listType" />
        </el-tab-pane>
        <el-tab-pane :label="`车辆${getName}`" name="plate">
          <list-plate v-if="tabActive == 'plate'" :type="listType" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:0
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */

import ListDriver from '@/views/logistics/ListDriver.vue';
import ListPlate from '@/views/logistics/ListPlate.vue';
import listMap from '@/views/logistics/listMap';
import eventIdMap from '@/views/logistics/eventIdMap';
export default {
  components: {
    ListDriver,
    ListPlate
  },
  props: {
    listType: {
      type: String,
      default: 'black'
    },
    name: {
      type: String,
      default: 'driver'
    }
  },
  computed: {
    getName() {
      return listMap[this.listType].name;
    },
    getTip() {
      return listMap[this.listType].tip;
    }
  },
  data() {
    return {
      viewDriverList: '',
      viewPlateList: '',
      tabActive: ''
    };
  },
  mounted() {
    if (this.$route.params.active) {
      if (this.$route.params.active == 'plate') {
        this.viewPlateList = ListPlate;
        this[eventIdMap.eventAction]({
          ctp: window.location.href,
          eventId: listMap[this.listType].plateListPageId.id,
          event: listMap[this.listType].plateListPageId.dec,
          logType: eventIdMap.pageEventType
        });
      } else {
        this.viewDriverList = ListDriver;
        this[eventIdMap.eventAction]({
          ctp: window.location.href,
          eventId: listMap[this.listType].driverListPageId.id,
          event: listMap[this.listType].driverListPageId.dec,
          logType: eventIdMap.pageEventType
        });
      }
      this.tabActive = this.$route.params.active;
    } else {
      this.tabActive = 'driver';
    }
  },
  methods: {
    tabChange(tab) {
      switch (this.tabActive) {
        case 'driver':
          this.$router.replace({
            path: `${listMap[this.listType].pathUrl}/driver`
          });
          break;
        case 'plate':
          this.$router.replace({
            path: `${listMap[this.listType].pathUrl}/plate`
          });
          break;
        default:
          break;
      }
    }
  }
};
</script>
<style scoped>
.blacklist-tips-con {
  font-size: 14px;
  color: #f90;
  padding: 10px 20px;
  background: #fdf6ec;
  border: 1px solid #f5dab1;
}
.yellow-control-tab {
  margin-top: 15px;
}
</style>
<style>
.yellow-control-tab .el-tabs__header {
  background: #fff;
  padding: 0 15px;
  margin-bottom: 0;
}
.yellow-control-tab .el-tabs__content {
  margin-top: 10px;
  background: #fff;
}
</style>
